import { IconProps } from "../../utils/global-types/global-types";

const UploadIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <g clipPath="url(#clip0_680_25052)">
      <path
        fill="currentColor"
        d="M13.257 14.482H9.78V10.97h1.149c.291 0 .463-.33.291-.57L8.987 7.31a.356.356 0 0 0-.58 0L6.173 10.4a.358.358 0 0 0 .291.57h1.149v3.512H3.72C1.982 14.386.6 12.761.6 11c0-1.215.658-2.274 1.635-2.847a2.242 2.242 0 0 1 2.877-2.88 4.49 4.49 0 0 1 4.068-2.578 4.5 4.5 0 0 1 4.468 4.061c1.791.308 3.152 1.967 3.152 3.843 0 2.006-1.563 3.744-3.542 3.883"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_680_25052">
        <path fill="#fff" d="M.599.599h16.2v16.2H.599z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default UploadIcon;
